import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestQuery from "@/remoteState/useRestQuery";
import { Metadata } from "@/view/ContentHead";

const useContentMetadataGet = (contentId: string | null) => {
  const requestUrl = `${MONOLITH_ORIGIN}/api/v3/content-document/${contentId}/metadata/`;
  return useRestQuery<Metadata[]>(requestUrl, { skip: !contentId });
};

export default useContentMetadataGet;
